import { Routes } from '@angular/router';

import { LangResolver } from './shared/services';
import { AuthGuard } from './core/guards/auth.guard';
import { SuperAdminGuard } from './core/guards/super-admin.guard';
import { RedirectLinkComponent } from './modules/redirect-link';
import { PublicGuard } from './core/guards/public.guard';
import { AddPaymentMethodPageGuard } from './core/guards/add-payment-method-page.guard';

const routesChildren: Routes = [
  {
    path: 'search',
    loadChildren: () => import('./modules/search/search.module').then((m) => m.SearchModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'folders',
    loadChildren: () => import('./modules/folders/folders.module').then((m) => m.FoldersModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'admin-panel',
    loadChildren: () =>
      import('./modules/admin-panel/admin-panel.routes').then((m) => m.ADMIN_PANEL_ROUTES),
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: 'integration-vacancies',
    loadChildren: () =>
      import('./modules/integration-vacancies/integration-vacancies.module').then(
        (m) => m.IntegrationVacanciesModule,
      ),
    canActivate: [AuthGuard, SuperAdminGuard],
  },
  {
    path: 'redirect/link/:link',
    component: RedirectLinkComponent,
    loadChildren: () =>
      import('./modules/redirect-link/redirect-link.module').then((m) => m.RedirectLinkModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-payment-method',
    loadChildren: () =>
      import('./modules/add-payment-method/add-payment-method.module').then(
        (m) => m.AddPaymentMethodModule,
      ),
    canActivate: [AuthGuard, AddPaymentMethodPageGuard],
  },
  {
    path: 'cs',
    loadChildren: () =>
      import('./modules/integration/integration.module').then((m) => m.IntegrationModule),
  },
  {
    path: 'campaign',
    loadChildren: () => import('./modules/campaign/campaign.module').then((m) => m.CampaignModule),
    canActivate: [AuthGuard],
  },
  /**
   {
    path: 'referral-program',
    loadChildren: () =>
      import('./modules/affiliate/affiliate.module').then((m) => m.AffiliateModule),
    data: { title: 'REFERRAL_PROGRAM.TITLE' },
    canActivate: [AuthGuard],
  },
   **/
  {
    path: 'ukrainian-talent',
    loadChildren: () =>
      import('./modules/public-search/public-search.routes').then((m) => m.PUBLIC_SEARCH_ROUTES),
    canActivate: [PublicGuard],
    data: { displayContentOnly: true },
  },
  {
    path: '',
    loadChildren: () => import('./modules/landing/landing.routes').then((m) => m.LANDING_ROUTES),
    canActivate: [PublicGuard],
  },
];

export const routes: Routes = [
  {
    path: ':lang',
    children: routesChildren,
    resolve: {
      lang: LangResolver,
    },
  },
  {
    path: '',
    redirectTo: 'en',
    pathMatch: 'full',
  },
];
